import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getPproDetails } from 'modules/activityDetails/PproDetails/api/pproDetailsService'
import { PproDetailsState, ApiPproDetailsResponse } from './types'

const initialState: PproDetailsState = {
  pproDetailsData: {},
}

const pproDetailsSlice = createSlice({
  name: 'pproDetails',
  initialState,
  reducers: {
    pproDetailsLoaded(state, action: PayloadAction<ApiMiddlewarePayload<ApiPproDetailsResponse>>) {
      state.pproDetailsData = action.payload
    },
    clearPproDetails(state) {
      state.pproDetailsData = initialState.pproDetailsData
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { pproDetailsLoaded, clearPproDetails } = pproDetailsSlice.actions

export { clearPproDetails }
export default pproDetailsSlice.reducer

export const loadPproDetailsData = (pproId: Guid, resultId?: Guid) => {
  return createApiAction({
    apiCalls: {
      pproDetails: () => getPproDetails(pproId, resultId),
    },
    payloadAction: pproDetailsLoaded,
    getResultToKeep: state => state.pproDetails.pproDetailsData.result,
  })
}
